import { DatePicker } from 'antd'
import {
  lastPeriodToDay,
  nextPeriodToDay,
  startEndRange,
  thisPeriodToDay,
} from 'utils/toMoment'
import { CIMSDateRangeProps } from './types'

const CIMSDateRange: React.VFC<CIMSDateRangeProps> = ({
  preventClear = false,
  ...props
}) => {
  const one = 1 as const
  return (
    <DatePicker.RangePicker
      {...props}
      allowClear={!preventClear}
      format="MM/DD/YYYY"
      ranges={{
        /**
         * days
         */
        Yesterday: startEndRange('day', { subtract: one }),
        Today: startEndRange('day'),
        Tomorrow: startEndRange('day', { add: one }),
        /**
         * weeks
         */
        'Last Week to Day': lastPeriodToDay('week'),
        'Last Week': startEndRange('week', { subtract: one }),
        'Last 7 Days': startEndRange('day', { subtract: { first: 7 } }),
        'This Week to Day': thisPeriodToDay('week'),
        'This Week': startEndRange('week'),
        'Next 7 Days': startEndRange('day', { add: { first: 0, last: 7 } }),
        'Next Week to Day': nextPeriodToDay('week'),
        'Next Week': startEndRange('week', { add: one }),
        /**
         * months
         */
        'Last Month to Day': lastPeriodToDay('month'),
        'Last Month': startEndRange('month', { subtract: one }),
        'Last 30 Days': startEndRange('day', { subtract: { first: 30 } }),
        'This Month to Day': thisPeriodToDay('month'),
        'This Month': startEndRange('month'),
        'Next 30 Days': startEndRange('day', { add: { first: 0, last: 30 } }),
        'Next Month to Day': nextPeriodToDay('month'),
        'Next Month': startEndRange('month', { add: one }),
        /**
         * years
         */
        'Last Year to Day': lastPeriodToDay('year'),
        'Last Year': startEndRange('year', { subtract: one }),
        'Last 365 Days': startEndRange('day', { subtract: { first: 365 } }),
        'This Year to Day': thisPeriodToDay('year'),
        'This Year': startEndRange('year'),
        'Next 365 Days': startEndRange('day', { add: { first: 0, last: 365 } }),
        'Next Year to Day': nextPeriodToDay('year'),
        'Next Year': startEndRange('year', { add: one }),
      }}
    />
  )
}

export default CIMSDateRange
